import axios from 'axios';
import CliError, { getErrorMessage } from '../../../utilities/CliError';
import { currentUser } from '../../../utilities/firestore';
import logger from '../../../utilities/logger';
import postToFirebaseFunction from '../../../utilities/postToFirebaseFunction';

export default async function queueSmokeTest({
  appId,
  buildId,
  contextUserId,
  nodeVersion,
  npmVersion,
  pnpmVersion,
  userId,
}: {
  appId: string;
  buildId: string;
  contextUserId?: string;
  nodeVersion?: string;
  npmVersion?: string;
  pnpmVersion?: string;
  userId: string;
}) {
  try {
    await postToFirebaseFunction('queueSmokeTest_HTTP', {
      appId,
      buildId,
      nodeVersion,
      npmVersion,
      pnpmVersion,
      userId,
      contextUserId,
      idToken: await currentUser()?.getIdToken(),
    });
  } catch (e) {
    logger.error({ error: e });
    throw buildQueueSmokeTestError(e);
  }
}

function buildQueueSmokeTestError(e: unknown): CliError {
  let detail = 'Unexpected internal error while testing build';
  if (axios.isAxiosError(e) && e.response?.data?.message) {
    detail = `${detail}; ${e.response.data.message}`;
  } else if (e) {
    detail = `${detail}; ${getErrorMessage(e)}`;
  }

  return new CliError(detail, { cause: e instanceof Error ? e : undefined });
}
